import layoutBottomMenu from '@/layout/bottom-menu'
// import { checkPlugins } from '@/views/plugins/index.js'
// 由于懒加载页面太多的话会造成webpack热更新太慢，所以开发环境不使用懒加载，只有生产环境使用懒加载
const _import = require('@/libs/util.import.' + process.env.NODE_ENV)
/**
 * 在主框架内显示
 */
const frameIn = [
   {
      path: '/',
      redirect: { name: 'index' },
      component: layoutBottomMenu,
      children: [
         // 控制台
         {
            path: 'index',
            name: 'index',
            meta: {
               title: '首页',
               auth: true,
               keepAlive: true,
            },
            component: _import('homePage/index'),
         },
         {
            path: 'contactPerson',
            name: 'contactPerson',
            meta: {
               title: '个人信息',
               auth: true,
            },
            component: _import('contactPerson/index'),
         },
         // 联系人详情
         {
            path: 'contactDetails',
            name: 'contactDetails',
            meta: {
               title: '联系人详情',
            },
            component: _import('contactDetails/index'),
         },
         // 个人中心
         {
            path: 'individualCenter',
            name: 'individualCenter',
            meta: {
               title: '个人中心',
            },
            component: _import('individualCenter/index'),
         },
         // 值班电话设置
         {
            path: 'dutyPhone',
            name: 'dutyPhone',
            meta: {
               title: '值班电话',
               auth: true,
            },
            component: _import('individualCenter/dutyPhone'),
         },
         // 未建立联系的联系人通话详情
         {
            path: 'callLogDetails',
            name: 'callLogDetails',
            meta: {
               title: '通话详情',
            },
            component: _import('callLogDetails/index'),
         },
         // 页面重定向 必须保留
         {
            path: 'redirect/:route*',
            name: 'redirect',
            hidden: true,
            component: _import('homePage/index'),
         },
         // 记录页面（合并外线/内线）
         {
            path: 'records',
            name: 'records',
            meta: {
               title: '记录',
               auth: true,
            },
            component: _import('records/index'),
         },
      ],
   },
]

/**
 * 在主框架之外显示
 */
const frameOut = [
   // 登录
   {
      path: '/login',
      name: 'login',
      meta: {
         title: '登录',
      },
      component: _import('login/index'),
   },
   {
      path: '/error',
      name: 'error',
      meta: {
         title: '错误页面',
      },
      component: _import('error/index'),
   },
   // 添加或者编辑联系人
   {
      path: '/addOrEditContacts',
      name: 'addOrEditContacts',
      meta: {
         title: '编辑联系人',
      },
      component: _import('addOrEditContacts/index'),
   },

   // 企业微信好友详情
   {
      path: '/enterpriseMicroFriendsDetails',
      name: 'enterpriseMicroFriendsDetails',
      component: _import('enterpriseMicroFriendsDetails/index'),
   },
]

/**
 * 错误页面
 */
const errorPage = [
   {
      path: '/404',
      name: '404',
      component: _import('404/index'),
   },
]

// 导出需要显示菜单的
export const frameInRoutes = frameIn

// 重新组织后导出
export default [...frameIn, ...frameOut, ...errorPage]
